import React from 'react';
import { object } from 'prop-types';
import NscTile from '../tiles/nsc_tile';
import TilesCarousel from '../tiles_carousel';
import './index.scss';

const NscTilesCarousel = (props) => (
    <div className="nsc-carousel">
        <div className="nsc-carousel-wrapper">
            <TilesCarousel {...props} TileComponent={NscTile}/>
        </div>
    </div>
);

NscTilesCarousel.propTypes = {
    props: object
};

export default NscTilesCarousel;
